/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourcePoolProviderType } from './resourcePoolProviderType';
import { ResourcePoolRequestStatusType } from './resourcePoolRequestStatusType';
import { ResourcePoolRequestOperationType } from './resourcePoolRequestOperationType';


export interface TenantResourcePoolEntrySpec { 
    /**
     * Assigned Resource Id
     */
    assigned_resource_id?: string;
    operation: ResourcePoolRequestOperationType;
    /**
     * Org id
     */
    org_id: string;
    provider_type: ResourcePoolProviderType;
    /**
     * Request id
     */
    request_id: string;
    request_spec: object;
    /**
     * Requested by
     */
    requested_by: string;
    status: ResourcePoolRequestStatusType;
    /**
     * Task Id
     */
    task_id?: string;
}
export namespace TenantResourcePoolEntrySpec {
}


